var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_3579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_3579)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V23H0V0Z",
    fill: "#FF6230"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23L23 0H0Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2402_3579)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14972 15.6485C3.14972 15.6485 2.06931 16.961 2.92597 17.03C3.78254 17.0992 3.62194 17.7955 4.3227 17.034C5.02346 16.2725 4.34372 17.1551 5.27839 16.9821C6.21276 16.8089 6.67991 15.2888 7.17333 15.3927C7.66629 15.4964 7.38076 15.2542 7.79609 15.9117C8.21152 16.5695 8.94124 15.1732 8.5518 16.1423C8.16266 17.1114 8.00685 18.0804 8.57799 18.0458C9.14895 18.0112 9.38256 17.5613 9.64208 17.0768C9.90169 16.5922 11.9265 18.2536 10.9922 16.5922C10.0575 14.9308 9.695 16.7743 9.6172 15.9091C9.53938 15.0438 9.3537 14.5939 9.79513 15.0092C10.2361 15.4245 11.2746 15.3207 10.4697 14.2823C9.66513 13.2441 9.77715 12.9673 9.54315 13.2441C9.30963 13.5209 8.7385 12.2058 9.54315 12.0328C10.3478 11.8596 11.2746 12.4479 11.5861 12.7594C11.8977 13.0711 12.8582 12.6903 13.0657 13.3131C13.2734 13.9363 13.9743 14.0401 14.1559 14.4209C14.3379 14.8017 14.2079 16.6705 15.6875 16.5667C17.1671 16.4628 17.6342 15.4591 17.0115 14.6631C16.3883 13.8671 16.4404 12.4133 15.7913 13.1057C15.1424 13.7977 14.2079 13.6939 14.2079 12.8633C14.2079 12.0328 14.4934 11.8943 14.4415 11.2366C14.3895 10.5789 14.3379 10.8559 15.2983 10.8904C16.2585 10.9251 15.921 10.8904 16.6219 10.4406C17.3229 9.99065 17.7901 11.9634 18.0757 10.5097C18.3612 9.05624 17.972 7.56782 17.1932 8.15621C16.4143 8.74459 16.4404 10.1983 15.4539 9.05624C14.4676 7.91384 14.0004 8.50223 14.3118 7.87924C14.6231 7.2564 14.2339 6.80642 14.9347 7.22159C15.6355 7.63719 15.4281 7.77543 16.0249 7.87924C16.6219 7.98306 19.7889 8.50223 19.0881 7.63718C18.3873 6.77182 17.7144 6.91293 17.6105 6.35901C17.5066 5.80536 17.9341 5.94377 18.557 5.63235C19.1801 5.32078 18.9203 3.72857 18.3231 4.04014C17.7263 4.35177 17.7772 5.73616 16.5572 4.87074C15.1574 5.68265 15.374 5.27524 14.6614 3.89917C14.038 3.24135 13.7006 3.20696 12.6365 3.96816C11.7966 4.43024 11.0938 5.28342 11.5351 6.4258C11.9765 7.56782 13.0276 9.71902 12.4567 9.85743C11.8855 9.99582 9.83487 7.95377 8.64076 9.02696C7.44659 10.0996 6.79478 11.1437 6.40564 12.3896C6.01622 13.6357 4.75619 14.3613 4.44459 14.3613C4.13316 14.3613 3.69458 15.0947 3.14972 15.6485Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2402_3579)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2402_3579",
    x: 0.595703,
    y: 1.40137,
    width: 20.5931,
    height: 18.6455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.184314 0 0 0 0 0 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2402_3579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2402_3579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_3579",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn);
export default __webpack_public_path__ + "static/media/BTN.9696e4593d15fd16a6727868594e2b40.svg";
export { ForwardRef as ReactComponent };